var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pointList.length)?_c('div',_vm._l((_vm.pointList),function(item,index){return _c('span',{key:index,staticClass:"footer-legend"},[_c('span',{staticClass:"footer-legend-point",class:_vm.getClass(item.type)}),_vm._v(" "),_c('span',{staticClass:"footer-legend-label"},[_vm._v(_vm._s(item.label))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }